import React from "react";
import { Field } from "react-final-form";
import { showError } from "./formUtils";
import TextField, { ITextFieldProps } from "../TextField";

export interface IOutlinedTextField extends ITextFieldProps {
  validate?: (value: any) => any;
  name: string;
  onFocus?: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onKeyDown?: (
    event: React.KeyboardEvent<HTMLInputElement> & { target: HTMLInputElement },
  ) => void;
  autoFocus?: boolean;
}

const OutlinedTextField = React.forwardRef<any, IOutlinedTextField>(
  (props, ref) => {
    const {
      disabled,
      helperText: userHelperText,
      endAdornment,
      label,
      onKeyDown,
      onFocus,
      autoFocus,
      validate,
      inputProps,
      InputProps,
      ...rest
    } = props;

    return (
      <Field
        validate={validate}
        render={({ input, meta, ...restTextField }) => {
          const isError = showError(meta);
          const helperText = isError ? meta.error : userHelperText;

          return (
            <TextField
              {...restTextField}
              {...input}
              disabled={meta.submitting || disabled}
              error={isError}
              helperText={helperText}
              label={label}
              endAdornment={endAdornment}
              onKeyDown={onKeyDown}
              onFocus={onFocus}
              ref={ref}
              autoFocus={autoFocus}
              InputProps={InputProps}
              inputProps={inputProps}
            />
          );
        }}
        {...rest}
      />
    );
  },
);

export default React.memo(OutlinedTextField);
